import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '@babel/types';

const TextInput = ({
    type,
    name,
    value,
    placeholder,
    onChange,
    maxLength,
    minLength,
    ...restProps
}) => {
    return (
        <input
            className="form-control"
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            minLength={minLength}
            {...restProps}
        />
    );
};

TextInput.propTypes = {
    // To define the type of the input for e.g (password, text, email)
    type: PropTypes.string,

    // To refrence the TextInput in the form
    name: PropTypes.string,

    // To set the value if required
    value: PropTypes.string,

    // To set the placeholder
    placeholder: PropTypes.string,

    // To set the max length
    maxLength: PropTypes.number,

    // To set the min length
    minLength: PropTypes.number,

    // To invoke a function on change of the value of TextInput
    onChange: PropTypes.func,
};

TextInput.defaultProps = {
    type: 'text',
    name: null,
    value: '',
    maxLength: null,
    minLength: null,
    placeholder: 'palceholder',
    onChange: noop,
};

export default TextInput;
